var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { styled } from 'styled-components';
import { useToggle } from '@hn-front/utils';
import { useCallback, useEffect, useState } from 'react';
import { ButtonsPanel } from './ButtonsPanel';
import { Header } from './Header';
import { AddStudentRow } from './Rows/AddStudentRow';
import { Body } from './Common';
import { StudentRow } from './Rows/StudentRows';
import { useStudents } from '../hooks/useStudents';
import { DeletedStudentsTable } from './DeletedStudentsTable';
import { usePassword } from '../hooks/usePassword';
var Container = styled.div.withConfig({ displayName: "Container", componentId: "sc-g3p29p" })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin-bottom: 24px;\n"], ["\n  margin-bottom: 24px;\n"])));
var columns = [
    {
        id: 0,
        name: '№',
    },
    {
        id: 1,
        name: 'Name',
    },
    {
        id: 2,
        name: 'Password',
    },
    {
        id: 3,
        name: null,
    },
];
var StudentsTable = function (_a) {
    var groupId = _a.groupId, groupData = _a.groupData;
    var groupType = groupData.type;
    var _b = useToggle(), isInAddMode = _b.isToggled, toggleAddMode = _b.toggle;
    var _c = useState([]), recoveredStudents = _c[0], setRecoveredStudents = _c[1];
    var _d = useStudents(groupId), students = _d.students, getAllStudents = _d.getAllStudents, deletedStudents = _d.deletedStudents, editStudent = _d.editStudent, addStudent = _d.addStudent, deleteStudent = _d.deleteStudent, recoverStudent = _d.recoverStudent, captureError = _d.captureError;
    var _e = usePassword(groupId), password = _e.password, getPassword = _e.getPassword, capturePasswordError = _e.captureError;
    var handleOnAddModeIn = function () {
        getPassword();
        toggleAddMode();
    };
    var handleOnAdd = function (student) {
        toggleAddMode();
        addStudent(student);
    };
    var handleOnDelete = useCallback(function (id) {
        deleteStudent(id);
        setRecoveredStudents(function (rs) { return rs.filter(function (studentId) { return studentId !== id; }); });
    }, [deleteStudent]);
    var handleOnRecover = function (id) {
        recoverStudent(id);
        setRecoveredStudents(function (rs) { return __spreadArray(__spreadArray([], rs, true), [id], false); });
    };
    var hasManyStudents = students.length >= 9;
    var shouldShowAddRow = isInAddMode && password;
    var isRecovered = useCallback(function (id) { return recoveredStudents.includes(id); }, [recoveredStudents]);
    useEffect(function () {
        getAllStudents();
    }, []);
    useEffect(function () {
        captureError();
    }, [captureError]);
    useEffect(function () {
        capturePasswordError();
    }, [capturePasswordError]);
    return (_jsxs(_Fragment, { children: [_jsx(ButtonsPanel, { groupId: groupId, groupType: groupType, shouldShowAddButton: hasManyStudents && groupType === 'manual', isUpperPanel: true, onAdd: hasManyStudents ? handleOnAddModeIn : undefined }, void 0), _jsxs(Container, { children: [_jsx(Header, { columns: columns }, void 0), _jsxs(Body, { children: [students.map(function (student, index) { return (_jsx(StudentRow, { isRecovered: isRecovered(student.id), groupType: groupType, groupId: groupId, index: index + 1, student: student, onUpdate: editStudent, onDelete: handleOnDelete }, student.id)); }), shouldShowAddRow && (_jsx(AddStudentRow, { password: password, index: students.length + 1, onAdd: handleOnAdd, onCancel: toggleAddMode }, void 0)), _jsx(DeletedStudentsTable, { students: deletedStudents, onRecover: handleOnRecover }, void 0)] }, void 0)] }, void 0), !shouldShowAddRow && (_jsx(ButtonsPanel, { groupId: groupId, groupType: groupType, shouldShowAddButton: true, onAdd: handleOnAddModeIn }, void 0))] }, void 0));
};
export { StudentsTable };
var templateObject_1;
